exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".MobilePopover .MuiPaper-root.MuiPaper-elevation{position:absolute;bottom:0;width:100%;max-width:none;background-color:transparent;margin:0}", ""]);
